if (!customElements.get('ss-announcement-slider')) {
  customElements.define('ss-announcement-slider', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-item]')];
      this.index = 0;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => {
          this.show(this.index + Number(button.dataset.direction));
          this.start();
        }, options);
      });
      this.addEventListener('mouseenter', () => this.stop(), options);
      this.addEventListener('mouseleave', () => this.start(), options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('focusout', () => setTimeout(() => this.start(), 0), options);
      document.addEventListener('visibilitychange', () => this.start(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.items.findIndex(item => item.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.editorSelection = true; this.stop(); this.show(index); }
      }, options);
      document.addEventListener('shopify:block:deselect', () => {
        this.editorSelection = false;
        this.start();
      }, options);
      this.start();
    }
    show(index) {
      this.index = (index + this.items.length) % this.items.length;
      this.items.forEach((item, i) => { item.hidden = i !== this.index; });
    }
    stop() { clearInterval(this.timer); }
    start() {
      this.stop();
      if (!this.isConnected || this.items.length < 2 || this.dataset.autoplay !== 'true' ||
          this.editorSelection || document.hidden || this.matches(':hover') ||
          this.contains(document.activeElement) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 5000);
    }
    disconnectedCallback() { this.stop(); this.events?.abort(); }
  });
}
